import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=7f0ff756&scoped=true&"
import script from "./SearchHistory.vue?vue&type=script&lang=js&"
export * from "./SearchHistory.vue?vue&type=script&lang=js&"
import style0 from "@/css/a.css?vue&type=style&index=0&id=7f0ff756&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ff756",
  null
  
)

export default component.exports